import { initializeApp, type FirebaseApp, type FirebaseOptions } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentSingleTabManager } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseEnvConfig: FirebaseOptions = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

const firebaseFallbackConfig: FirebaseOptions = {
  apiKey: "AIzaSyDvtnDtKj9KHan1hXZ6dKFh-E9WpKjf7DY",
  authDomain: "imobi-40b2b.firebaseapp.com",
  projectId: "imobi-40b2b",
  storageBucket: "imobi-40b2b.firebasestorage.app",
  messagingSenderId: "639801267534",
  appId: "1:639801267534:web:4202378ed9e9a6ca80fa1f"
};

function hasRequiredFirebaseFields(config: FirebaseOptions) {
  return Boolean(config.apiKey && config.projectId && config.appId);
}

const firebaseConfig = hasRequiredFirebaseFields(firebaseEnvConfig) ? firebaseEnvConfig : firebaseFallbackConfig;

export const hasFirebaseConfig = hasRequiredFirebaseFields(firebaseConfig);

if (!hasRequiredFirebaseFields(firebaseEnvConfig) && import.meta.env.PROD) {
  console.warn("IMOBI usando configuracao Firebase publica de fallback. Revise as variaveis VITE_FIREBASE_* do ambiente de build.");
}

function createFirestore(app: FirebaseApp) {
  try {
    return initializeFirestore(app, {
      localCache: persistentLocalCache({ tabManager: persistentSingleTabManager({}) })
    });
  } catch (error) {
    console.warn("Nao foi possivel ativar a persistencia offline do Firestore. Continuando apenas em memoria.", error);
    return initializeFirestore(app, {});
  }
}

export const firebaseApp: FirebaseApp | null = hasFirebaseConfig ? initializeApp(firebaseConfig) : null;
export const auth = firebaseApp ? getAuth(firebaseApp) : null;
export const db = firebaseApp ? createFirestore(firebaseApp) : null;
export const storage = firebaseApp ? getStorage(firebaseApp) : null;
export const functions = firebaseApp ? getFunctions(firebaseApp, "southamerica-east1") : null;
